module.exports = __webpack_public_path__ + "img/room_4.cd37c325.jpg";